import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Form, Input, Collapse } from 'reactstrap';
import { connect } from 'react-redux';
import {
  setShippingMethod,
  setDate,
  setPickUpTime,
  sendPickUpData,
} from '../actions/checkOutActions';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { useHistory } from 'react-router-dom';
import TimePicker from 'react-bootstrap-time-picker';
import ButtonSpinner from './ButtonSpinner';
import classnames from 'classnames';
import Holidays from 'date-holidays';

const Shipping = ({
  checkout,
  shoppingCart,
  config,
  nextStep,
  setShippingMethod,
  setDate,
  setPickUpTime,
  sendPickUpData,
}: any) => {
  const history = useHistory();
  const [windowWidth, setWindowWidth] = useState(0);
  const prevButtonLoadingRef = useRef(checkout.buttonLoading);

  const updateWindowDimension = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    window.addEventListener('resize', updateWindowDimension);

    let time = new Date().getHours();
    if (time < 14 && time >= 10) {
      setPickUpTime(time * 3600);
    } else {
      setPickUpTime(10 * 3600);
    }

    return () => {
      window.removeEventListener('resize', updateWindowDimension);
    };
  }, []);

  useEffect(() => {
    if (
      prevButtonLoadingRef.current !== checkout.buttonLoading &&
      !checkout.buttonLoading &&
      Object.keys(checkout.errors).length === 0
    ) {
      nextStep();
    }
    prevButtonLoadingRef.current = checkout.buttonLoading;
  }, [checkout.buttonLoading]);

  const nextStepHandler = (e) => {
    e.preventDefault();

    if (checkout.shippingMethod === 'pickup') {
      let data = {
        date: checkout.date,
        time: checkout.pickupTime,
      };
      sendPickUpData(data);
    } else {
      nextStep();
    }
  };

  const setShippingMethodHandler = (e) => {
    setShippingMethod(e.target.name);
  };

  const setDateHandler = (date) => setDate(date);

  const isPublicHoliday = (date) => {
    var hd = new Holidays('AU');
    return hd.isHoliday(date);
  };

  const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };

  const isClosedDatesForPickups = (date) => {
    const closedDates = config.closedDatesForPickup.split(',').map((d) => d.trim()) || [];
    return closedDates.includes(moment(date).format('DD-MM-YYYY'));
  };

  const isClosedDatesForDelivery = () => {
    const closedDates = config.closedDatesForDelivery.split(',').map((d) => d.trim()) || [];
    return !closedDates.includes(moment(new Date()).format('DD-MM-YYYY'));
  };

  const checkDate = (date) => {
    let weekday = isWeekday(date);
    let publicHoliday = isPublicHoliday(date);
    let closedDates = isClosedDatesForPickups(date);
    return weekday && !publicHoliday && !closedDates;
  };

  const handleTimeChange = (time) => {
    setPickUpTime(time);
  };

  let time = new Date().getHours();
  var today = new Date();
  var isToday;
  if (checkout.date !== null) {
    isToday = today.toDateString() === checkout.date.toDateString();
  }

  return (
    <div className="ml-3">
      <div className="mx-3 py-3">
        <h5 className="mx-2 py-3 text-muted font-weight-bold">Shipping Method</h5>
        <div className="border ">
          <Row className="mx-3 py-3  border-bottom ">
            <Col xs="12">
              <Form className="d-inline pr-3">
                <Input
                  type="radio"
                  name="pickup"
                  checked={checkout.shippingMethod === 'pickup'}
                  onChange={setShippingMethodHandler}
                />
              </Form>
              Store Pick Up
              <p className="text-muted pl-3">11 Saligna Dr, Tullamarine VIC 3043</p>
            </Col>

            <Collapse isOpen={checkout.shippingMethod === 'pickup'}>
              <Col className="mx-3 py-3">
                <p>Select a pickup date</p>
                <DatePicker
                  selected={checkout.date}
                  onChange={setDateHandler}
                  filterDate={checkDate}
                  placeholderText="Select a day"
                  minDate={moment().toDate()}
                  excludeDates={time >= 14 && [new Date()]}
                  dateFormat="dd/MM/yyyy"
                  className={classnames('form-control', {
                    'is-invalid': checkout.errors.date,
                  })}
                />
                <div className="invalid-feedback">{checkout.errors.date}</div>
                <TimePicker
                  onChange={handleTimeChange}
                  value={checkout.pickupTime}
                  className={classnames('mt-3', {
                    'is-invalid': checkout.errors.time,
                  })}
                  start={isToday ? (time >= 14 ? '10' : `${time + 2}`) : '10'}
                  end="16"
                  step={60}
                />
                <div className="invalid-feedback">{checkout.errors.time}</div>
              </Col>
            </Collapse>
          </Row>
          {isClosedDatesForDelivery() && (
            <Row className="mx-3 py-3  ">
              <Col xs="9">
                <Form className="d-inline pr-3">
                  <Input
                    type="radio"
                    checked={checkout.shippingMethod === 'delivery'}
                    onChange={setShippingMethodHandler}
                    name="delivery"
                  />
                </Form>
                Standard Shipping (1 to 3 days)
              </Col>
            </Row>
          )}
        </div>

        <div>
          <Row className="my-3">
            <Col>
              <Button
                disabled={checkout.buttonLoading}
                size="sm"
                color="dark"
                outline
                className="border-0 font-weight-bold"
                onClick={() => history.push('/cart')}
              >
                &lt; Back to Cart
              </Button>
            </Col>

            <Col className="text-right" style={{ marginRight: windowWidth < 500 && 50 }}>
              <Button
                size="sm"
                disabled={
                  checkout.shippingMethod === null ||
                  (checkout.shippingMethod === 'pickup' &&
                    (checkout.pickupTime === 0 || checkout.date === null))
                }
                color="success"
                onClick={nextStepHandler}
                style={{ minWidth: 182 }}
              >
                {checkout.buttonLoading ? (
                  <ButtonSpinner />
                ) : (
                  <span> Continue to User Details &gt;</span>
                )}
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  checkout: state.checkout,
  shoppingCart: state.cart,
  guest: state.guest,
  config: state.config,
});

export default connect(mapStateToProps, {
  setShippingMethod,
  setDate,
  setPickUpTime,
  sendPickUpData,
})(Shipping);
